import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-container">
      <div className="payment-cancel">
        <XCircle size={64} className="cancel-icon" />
        <h2>Payment Cancelled</h2>
        <p>Your payment has been cancelled. No charges were made.</p>
        
        <div className="action-buttons">
          <button
            onClick={() => navigate('/payment')}
            className="retry-button"
          >
            Try Again
          </button>
          
          <button
            onClick={() => navigate('/investor')}
            className="back-button"
          >
            <ArrowLeft size={20} />
            Return to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;